/** Native bridge exposed by TekMegha Android WebView (`com.tekmegha.digital`). */
export type TekMeghaAppBridge = {
  getFcmToken?: () => string;
  downloadBase64?: (b64: string, name: string, mime: string) => void;
  pickImage?: () => void;
};

declare global {
  interface Window {
    TekMeghaApp?: TekMeghaAppBridge;
    isTekMeghaApp?: boolean;
    __tekMeghaFcmToken?: string;
  }
}

export function isTekMeghaAndroidApp(): boolean {
  if (typeof window === 'undefined') return false;
  if (window.isTekMeghaApp === true) return true;
  if (window.TekMeghaApp) return true;
  try {
    if (localStorage.getItem('tekmegha_app_detected') === 'true') return true;
    if (localStorage.getItem('tekmegha_app_source') === 'android-app') return true;
  } catch {
    /* ignore */
  }
  return /TekMeghaApp\//i.test(navigator.userAgent || '');
}

/** Read FCM token from Android bridge or values injected into the page. */
export function readTekMeghaFcmToken(): string | null {
  if (typeof window === 'undefined') return null;

  try {
    const fromBridge = window.TekMeghaApp?.getFcmToken?.();
    if (typeof fromBridge === 'string' && fromBridge.trim()) {
      return fromBridge.trim();
    }
  } catch {
    /* bridge may throw if WebView not ready */
  }

  const injected = window.__tekMeghaFcmToken;
  if (typeof injected === 'string' && injected.trim()) {
    return injected.trim();
  }

  try {
    const stored = localStorage.getItem('tekmegha_fcm_token');
    if (stored?.trim()) return stored.trim();
  } catch {
    /* ignore */
  }

  return null;
}
